import { render } from "./AgreementView.vue?vue&type=template&id=bb8d1982"
import script from "./AgreementView.vue?vue&type=script&lang=js"
export * from "./AgreementView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__